import moment from 'moment'
import dayjs, { Dayjs } from 'dayjs'
import utc from 'dayjs/plugin/utc'

// import 'moment/locale/ru'
// import 'moment/locale/uk'
// import 'moment/locale/pl'

import { storeLocal } from '../stores'

dayjs.extend(utc)

/**
 * Календарный день (дата сгорания баллов и т.п.) как unix-время полуночи UTC этого дня:
 * бэкенд хранит даты в UTC. Локальная полночь из DatePicker восточнее UTC — это ещё предыдущий день
 */
export const dayToUtcTimestamp = (date: Dayjs) => dayjs.utc(date.format('YYYY-MM-DD')).unix()

/**
 * Обратно — значение для DatePicker: тот же день в локальном поясе
 */
export const utcTimestampToDay = (timestamp: number) => dayjs(dayjs.unix(timestamp).utc().format('YYYY-MM-DD'))

/**
 * Получение строкового представления времени в формате HH:MM
 */

export const getString = (timestamp: number) => {
    let date = new Date(timestamp * 1000)
    return `${('0' + (date.getUTCHours())).slice(-2)}:${('0' + (date.getUTCMinutes())).slice(-2)}`
}

/**
 * Получить секунды из строкового представления времени
 */
export const getSeconds = (time: string) => {
    const workTime = time.split(":")

    let seconds = 0

    if(Number(workTime[0]) > 0) {
        seconds = seconds + Number(workTime[0]) * 60 * 60
    }

    if(Number(workTime[1]) > 0) {
        seconds = seconds + Number(workTime[1]) * 60
    }

    return seconds
}

export const moment_custom = (value: number, format: string) => {
    let local = storeLocal.get('lang') ? storeLocal.get('lang') : process.env.REACT_APP_DEFAULT_LANGUAGE ?? 'en'
    if(local === 'ua') local = 'uk'
    try {
        require(`moment/locale/${local}`)
    } catch (e) {}
    return moment.utc(value).locale(local).format(format)
}